module.exports = __webpack_public_path__ + "static/media/loader.163fa539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loader.svg
// module id = 915
// module chunks = 0